export const WC_PORTALS = {
  AGENT: "MOD401",
  MEMBER: "MOD402"
};
